// test1906
(1906 && 0);
